import React, { Fragment, useState } from "react";
// import QrReader from 'react-qr-scanner'
import QrReader from "react-qr-reader";

import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import { getIdenticator } from '../../api/directory';
import FContainer from "../../components/FContainer/FContainer";

const ReadQrSendFiadoScreen = ({ param }) => {
  const route = useNavigate();
  const [scanned, setScanned] = useState(true);


  const handleError = (err) => {
    console.error(!err)
  }


  const handleScan = (data) => {

    const handleBarCodeScanned = async (datos) => {
      const { data } = await getIdenticator(datos.phoneNumber);
      const userInfo = data.data;

      if (datos.type == 'dynamic') {
        console.log(datos.type, {
          name: userInfo.name,
          directoryId: userInfo.directoryId,
          phoneNumber: datos.phoneNumber,
          concept: datos.concept,
          amount: datos.amount,

        })

        route("/QrDynamicScreen", {
          state: {
            name: userInfo.name,
            directoryId: userInfo.directoryId,
            phoneNumber: datos.phoneNumber,
            concept: datos.concept,
            amount: datos.amount,
          },
        });
        setScanned(false)
      }
      else if (datos.type == 'static') {
        console.log(datos.type, {
          name: userInfo.name,
          directoryId: datos.directoryId,
        })
        route("/QrStaticScreen", {
          state: {
            name: userInfo.name,
            directoryId: datos.directoryId,
          },
        });
        setScanned(false)
      }
      else {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: 'El QR no es valido',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          confirmButtonText: 'Entendido'
        }).then((result) => {
          if (result.isConfirmed) {
            route("/ShareFiadoScreen");
          } else {
            route("/ShareFiadoScreen");
          }
        })
        setScanned(false)

      }
    };


    if (data) {
      if (scanned) {
        try {
          let datos = JSON.parse(data)
          handleBarCodeScanned(datos)
          setScanned(false)
        } catch (error) {
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: 'El QR no es valido',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            confirmButtonText: 'Entendido'
          }).then((result) => {
            if (result.isConfirmed) {
              route("/ShareFiadoScreen");
            } else {
              route("/ShareFiadoScreen");
            }
          })
          setScanned(false)
        }
      }
    }
  }

  return (
    <>
      <FContainer>
        <QrReader
          facingMode={"environment"}
          delay={2}
          className="!rounded-3xl"
          style={{ width: "100%", heigth: "100%", borderRadius: 100 }}
          onError={handleError}
          onScan={handleScan}
        />
      </FContainer>
    </>
  );
};

export default ReadQrSendFiadoScreen;
